var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{class:{tax: true, last: _vm.isLast}},[_c('td',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('td',{directives:[{name:"mny",rawName:"v-mny",value:((_vm.total)),expression:"(total)"}]}),_vm._v(" "),_c('td')])
}
var staticRenderFns = []

export { render, staticRenderFns }